export const gutterWidth = 12;

const grid = {
  gutterWidth
};

export default grid;
